import * as actionTypes from '../../../../models/actionTypes';
import { AlchemyInsightModel } from '../../../../models/apiModels';

export const dismissUserNotice = (noticeId: string) => {
  return {
    type: actionTypes.DISMISS_NOTICE,
    noticeId,
  };
};

export const fetchUserNoticesSuccess = (userNotices: AlchemyInsightModel[]) => {
  return {
    type: actionTypes.FETCH_USER_NOTICES_SUCCESS,
    userNotices,
  };
};

export const fetchUserNoticesError = () => {
  return {
    type: actionTypes.FETCH_USER_NOTICES_ERROR,
  };
};
